import React, { useEffect, useState } from 'react';

const Loader = () => {
    const [time, setTime] = useState(0);

    useEffect(() => {
        const timer = window.setInterval(() => {
            setTime(time + 1);
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    return (
        <div
            className="portal-loading-placeholder"
            style={{ marginBottom: '200px' }}
        >
            <div className="norlys-spinner"></div>

            {/*<div style={{ textAlign: 'center' }}>*/}
            {/*    {time < 3 ? <p>Et øjeblik ...</p> : null}*/}
            {/*    {time > 3 && time < 8 ? (*/}
            {/*        <p>Et adresseopslag tager som regel 1 til 10 sekunder.</p>*/}
            {/*    ) : null}*/}
            {/*    {time > 8 && time < 13 ? (*/}
            {/*        <p>Nogle gange tager det lidt længere tid ...</p>*/}
            {/*    ) : null}*/}
            {/*    {time > 13 && time < 17 ? (*/}
            {/*        <p>Så tak for din tålmodighed.</p>*/}
            {/*    ) : null}*/}
            {/*    {time > 20 ? (*/}
            {/*        <p>*/}
            {/*            Wow! Det her tager virkelig lang tid. Beklager*/}
            {/*            ventetiden!*/}
            {/*        </p>*/}
            {/*    ) : null}*/}
            {/*</div>*/}
        </div>
    );
};

export default Loader;
